class RunException<D = unknown> extends Error {
	readonly data?: D;

	constructor(message?: string, options?: { cause?: unknown; data?: D }) {
		super(message, { cause: options?.cause });

		this.name = "RunError";
		this.data = options?.data;
	}
}

export { RunException };
